import './App.css';
import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Provider } from 'react-redux';
import { configureStore } from '@reduxjs/toolkit';
import { featuresReducer } from './features/featuresSlice';
import Dashboard from './pages/Dashboard';
import Login from './pages/Login';
import CreateSurvey from './pages/CreateSurvey';
import CreateSurveyForm from './pages/CreateSurveyForm';
import AdminSurveyAnalytics from './components/surveys/AdminSurveyAnalytics';
import AdminChatAnalytics from './pages/AdminChatAnalytics';

const store = configureStore({
  reducer: {
    features: featuresReducer,
  },
});

function PrivateRoute({ children }) {
  const auth = store.getState().features.auth;
  return auth ? children : <Navigate to="/login" />;
}

function LoginRoute({ children }) {
  const auth = store.getState().features.auth;
  return auth ? <Navigate to="/dashboard" /> : children;
}

function App() {
  return (
    <React.StrictMode>
      <Provider store={store}>
        <BrowserRouter>
          <Routes>
            {/* Redirect root path to login */}
            <Route path="/" element={<Navigate to="/login" replace />} />
            <Route 
              path="/login" 
              element={
                <LoginRoute>
                  <Login />
                </LoginRoute>
              } 
            />
            <Route 
              path="/dashboard" 
              element={
                <PrivateRoute>
                  <Dashboard />
                </PrivateRoute>
              } 
            />
            {/* Survey Creation Routes */}
            <Route 
              path="/dashboard/surveys/create" 
              element={
                <PrivateRoute>
                  <CreateSurvey />
                </PrivateRoute>
              } 
            />
            <Route 
              path="/dashboard/surveys/create/:type" 
              element={
                <PrivateRoute>
                  <CreateSurveyForm />
                </PrivateRoute>
              } 
            />
            <Route 
              path="/dashboard/surveys/edit/:type/:id" 
              element={
                <PrivateRoute>
                  <CreateSurveyForm />
                </PrivateRoute>
              } 
            />
            <Route 
              path="/dashboard/surveys/analytics/:id" 
              element={
                <PrivateRoute>
                  <AdminSurveyAnalytics />
                </PrivateRoute>
              } 
            />
            <Route 
              path="/admin/chat/:id" 
              element={
                <PrivateRoute>
                  <AdminChatAnalytics />
                </PrivateRoute>
              } 
            />
            {/* Add a catch-all route for 404 */}
            <Route path="*" element={<Navigate to="/login" />} />
          </Routes>
        </BrowserRouter>
      </Provider>
    </React.StrictMode>
  );
}

export default App;